import React from 'react';
import { Nav, MaestroComponent, IconProps } from '@landr/maestro';
import { NavigationDropdownItem } from './NavigationDropdownItem';
import { NavCollapse } from './NavigationMobile';

export interface DropdownItemsProps {
    path: string;
    title: string;
    icon: MaestroComponent<IconProps, Record<string, any>>;
    isBrowserOnly?: boolean;
    target?: React.HTMLAttributeAnchorTarget;
    subTitle: string;
}

interface NavigationDropdownProps {
    text: string;
    dropdownItems?: Array<DropdownItemsProps>;
    onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
    isMobile: boolean;
    icon: React.ElementType;
}

export const NavigationDropdown: React.FC<NavigationDropdownProps> = ({
    text,
    dropdownItems,
    onClick,
    isMobile,
    icon,
}) => {
    if (isMobile) {
        return (
            <NavCollapse.Head key={text} title={text} icon={icon}>
                {dropdownItems &&
                    dropdownItems.length > 0 &&
                    dropdownItems.map((item: DropdownItemsProps) => (
                        <NavCollapse.Item
                            key={item.title}
                            onClick={onClick}
                            path={item.path}
                            text={item.title}
                            target={item?.target}
                        />
                    ))}
            </NavCollapse.Head>
        );
    }

    return (
        <Nav.Dropdown key={text} triggerEvent={isMobile ? 'click' : 'hover'}>
            <Nav.DropdownTrigger>{text}</Nav.DropdownTrigger>
            <Nav.DropdownContent>
                {dropdownItems &&
                    dropdownItems.length > 0 &&
                    dropdownItems.map((item: DropdownItemsProps) => (
                        <NavigationDropdownItem
                            key={item.title}
                            icon={item.icon}
                            title={item.title}
                            subTitle={item.subTitle}
                            onClick={onClick}
                            path={item.path}
                            target={item?.target}
                        />
                    ))}
            </Nav.DropdownContent>
        </Nav.Dropdown>
    );
};
